module.exports = __webpack_public_path__ + "img/art-composer-present.9ca9c267.png";